/**
 * Created by nijin on 29/12/16.
 */
import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {ThingModel, IThingBasicInfo} from './model/Ithing.model';
import {Observable, Subject} from 'rxjs';
import {RequestOptions, Response, URLSearchParams} from '@angular/http';
import {SchemaService} from '../schema/schema.service';
import {HttpService} from '../auth/http.client.service';
import {NotificationBarService} from '../core/notify/notification.service';
import {NotificationType} from '../core/notify';
import {AuthService} from '../auth/auth.service';

@Injectable()
export class ThingsService {
  private  thingsURI = `${environment.serviceBase}/accounts/:accountId/things`;
  private connectionURI = `${environment.serviceBase}/connections`;
  private tagURI = `${environment.serviceBase}/accounts/:accountId/tags`;
  private eventURI = environment.eventURI;
  private latestEventURI = environment.latestEventURI;
  private middleURI = environment.middleURI;
  private thing: ThingModel;
  private thingSubject: Subject<any> = new Subject<any>();
  private thingSubscription = this.thingSubject.asObservable();

  constructor(private http: HttpService,
              private schemaService: SchemaService,
              private notifier: NotificationBarService ,
              private authService: AuthService,
  ) { }

  setThingBasicInfo(basicInfo: IThingBasicInfo, tags) {
    if (!this.thing) {
       this.thing = new ThingModel();
    }
    this.thing.name = basicInfo.name;
    this.thing.description = basicInfo.description;
    this.thing.tags = tags;
  }

  getThingDetails(thingId: number, args): Observable<any> {
    let uri = this.http.buildPath(this.thingsURI, {accountId: this.authService.getCurrentAccount().id, id: thingId});
    let search = this.setParams(args);
    let options = new RequestOptions({ search: search });
    return this.http.get(`${uri}/${thingId}`, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getAllThings(args?: any): Observable<any> {
    let uri = this.http.buildPath(this.thingsURI, {accountId: this.authService.getCurrentAccount().id});
    let search = this.setParams(args);
    let options = new RequestOptions({ search: search });
    return this.http.get(uri, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  getThingEvents(thingId, params) {
    let uri = this.http.buildPath(this.thingsURI, {accountId: this.authService.getCurrentAccount().id, id: thingId});
    let search = this.setParams(params);
    let options = new RequestOptions({ search: search });
    return this.http.get(`${uri}/${thingId}/events`, options)
      .map(this.extractData)
      .catch(this.handleError);

  }

  getLatestEvent(param) {
    let uri = this.http.buildPath(this.latestEventURI, {accountId: this.authService.getCurrentAccount().id});
    let search = this.setParams(param);
    let options = new RequestOptions({ search: search });
    return this.http.get(`${uri}`, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getAllConnections(): Observable<any> {
    return this.http.get(this.connectionURI)
      .map(this.extractData)
      .catch(this.handleError);

  }

  clone(number, thingId) {
    let data = { numberOfCopies: number };
    let uri = this.http.buildPath(this.thingsURI, {accountId: this.authService.getCurrentAccount().id});
    return this.http.post(`${uri}/${thingId}/clone`, data)
      .map((response) => response.json())
      .catch(this.handleError);
  }

  getTags(args): Observable<any> {
    let uri = this.http.buildPath(this.tagURI, {accountId: 1});
    let params: URLSearchParams = new URLSearchParams();
    params.set('name', args);
    let options = new RequestOptions({search: params });
    return this.http.get(uri, options)
      .map((response) => <any[]> response.json().data.items)
      .catch(this.handleError);
  }

  addTag(tag): Observable<any> {
    let data = {name: tag, accountId: this.authService.getCurrentAccount().id};
    let uri = this.http.buildPath(this.tagURI, {accountId: this.authService.getCurrentAccount().id});
    return this.http.post(uri, data)
      .map(this.extractData)
      .catch((error) => error);
  }

  saveThing(): Observable<any> {
    this.setSchemaInfo();
    this.thing.token = this.schemaService.getThingToken();
     let uri = this.http.buildPath(this.thingsURI, {accountId: this.authService.getCurrentAccount().id});
    return this.http.post(uri, this.thing)
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateThing(thing): Observable<any> {
    let id = thing.token;
    thing.secureGroup = null;
    let uri = this.http.buildPath(this.thingsURI, {accountId: this.authService.getCurrentAccount().id});
    return this.http.put(`${uri}/${id}`, thing)
      .map(this.updateThingSuccessCb)
      .catch(this.handleError);
  };

  setThingConnection(connection) {
    this.thing.connection.name = connection.protocolName;
    this.thing.connection.id = connection.id;
  }

  deleteThing(thing) {
    let id = thing.token;
    let uri = this.http.buildPath(this.thingsURI, {accountId: this.authService.getCurrentAccount().id});
    return this.http.delete(`${uri}/${id}`)
      .map((response) => {
        return response.json(); })
      .catch(this.handleError);
  }

  getSchemaMappedToThing(thing):  Observable<any> {
    return this.schemaService.getSchema(thing.schema.id);
  }

  getEventData(thing?, schema?) {
      return this.schemaService.getEventData({thing: thing, schema: schema});
  }

  publishEvent(event) {
    return this.http.post(this.eventURI, event)
      .map(this.extractData)
      .catch(this.handleError);
  }
  getThingCreateSubject() {
    return this.thingSubscription;
  }

    updateThingSubject(thing, isApp) {
     this.thingSubject.next({thing: thing, isApp: isApp});
  };
//middleware call
  getMobileAppDetails() {
    let uri = this.http.buildPath(this.middleURI, {accountId: this.authService.getCurrentAccount().id});
      return this.http.get(uri)
        .map(this.extractData)
        .catch(() => {return Observable.throw(false); });
  }
  deleteThingMiddleware(thing) {
    let uri = this.http.buildPath(this.middleURI, {accountId: this.authService.getCurrentAccount().id});
    return this.http.delete(`${uri}/${thing.token}`)
      .map((response) => { return response.json(); })
      .catch(this.handleError);
  }

  saveAppDetails() {
    this.setSchemaInfo();
    this.thing.token = this.schemaService.getThingToken();
    let uri = this.http.buildPath(this.middleURI, {accountId: this.authService.getCurrentAccount().id});
    return this.http.post(uri, this.thing)
      .map(this.extractData)
      .catch(this.handleError);
  }


  private setSchemaInfo() {
    let schema = this.schemaService.getCurrentSchema();
    if (schema) {
      this.thing.schema.id = schema.id;
      this.thing.schema.name = schema.name;
    }
  }


   private setThingSchemaDetails = (schema) => {
    this.thing.schema.name = schema.name;
    this.thing.schema.id = schema.id;
  }



  private setParams = (args) => {
    let params: URLSearchParams = new URLSearchParams();
    for (const key in args) {
      if (args.hasOwnProperty(key)) {
        params.set(key, args[key]);
      }
    }

    return params;
  }

  private updateThingSuccessCb = (res: Response) => {
    return res.json();
  }

  private extractData = (res: Response) => {
    let body = res.json();
    return body.data || { };
  }

  private handleError =  (error: Response | any) => {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      errMsg = body.status ? body.status.message : body;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    this.notifier.create({message: errMsg, type: NotificationType.Error});
    return Observable.throw(errMsg);
  }




}



// WEBPACK FOOTER //
// ./src/app/things/things.service.ts